import PropTypes from 'prop-types';
import React from 'react';

const HubBasePageLayout = ({ children }) => {
  return <div className="flex flex-col text-grey-6">{children}</div>;
};

HubBasePageLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default HubBasePageLayout;
